module.exports = __webpack_public_path__ + "static/media/background-blue.a0492d71.jpg";